import styled from 'styled-components';

export const Slide = styled.div`
	width: 100%;
	min-height: 120px;
	display: flex;
	align-items: flex-start;
	padding: 13px 10px 10px 10px;
	background: ${({ theme }) => theme.colors.bg8};
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.09);
	border-radius: 10px;
`;

export const Header = styled.div`
	min-width: 72px;
	min-height: 72px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	border: 1px solid #ffd400;
	border-radius: 50%;
	margin-right: 14px;
	position: relative;
`;

export const Avatar = styled.img`
	max-width: 64px;
	object-fit: cover;
	border-radius: 50%;
`;

export const UserName = styled.h4`
	position: absolute;
	bottom: -18px;
	left: 50%;
	transform: translate(-50%, 0);
	font-size: 10px;
	line-height: 11px;
	color: ${({ theme }) => theme.colors.text1};
	font-style: italic;
	width: max-content;
`;

export const Review = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	margin-top: 3px;

	p {
		font-size: 11px;
		line-height: 13px;
		color: ${({ theme }) => theme.colors.text1};
	}
`;

export const ReviewsRating = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 7px;

	img {
		width: 80px;
		object-fit: cover;
		margin-right: 3px;
	}

	p {
		font-weight: bold;
	}
`;
